import { IAppState } from '../../../AppModulesWrapper';

export function selectPromotionCost(state: IAppState): number {
  return state.servicePickerWidget.checkoutInfo.promotionCost;
}
